(function() {
  'use strict';

  // Prevent loop by setting a session flag
  const redirectedFlag = 'cart_redirect_done';

  // If on the cart page, redirect to homepage with flag
  if (location.pathname === '/cart' || location.pathname.includes('/cart')) {
    if (!sessionStorage.getItem(redirectedFlag)) {
      console.log('Cart page detected, redirecting to homepage...');
      sessionStorage.setItem(redirectedFlag, 'true');
      location.href = "/?open_cart=true";
    } else {
      console.log('Already redirected once, skipping to prevent loop.');
    }
    return;
  }

  // On homepage, check if we should open the cart
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('open_cart') === 'true') {
    console.log('Opening cart drawer...');
    
    let attempts = 0;
    const maxAttempts = 5;

    const openCart = () => {
      attempts++;
      console.log(`Attempt ${attempts} to find cart icon...`);

      const cartIcon = document.querySelector('#cart-icon-bubble');

      if (cartIcon) {
        console.log('Cart icon found, clicking...');
        cartIcon.click();

        // Clean up URL
        const newUrl = window.location.origin + window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);

        // Clear redirect flag so future visits work normally
        sessionStorage.removeItem(redirectedFlag);

        console.log('Cart opened successfully');
        return;
      }

      if (attempts < maxAttempts) {
        console.log(`Attempt ${attempts} failed, retrying in 1 second...`);
        setTimeout(openCart, 1000);
      } else {
        console.error('Failed to open cart after', maxAttempts, 'attempts');
      }
    };

    // Start trying to open after a short delay
    setTimeout(openCart, 500);
  } else {
    // Clear flag if user navigates normally
    sessionStorage.removeItem(redirectedFlag);
  }

})();
